import styled from "styled-components";
import { breakpoints } from "../helpers/breakpoints";
import { colors } from "../../components/helpers/functions";

export const QuizWrapper = styled.div`
    top: 0;
    left: 0;
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    overflow-y: auto;
    
    .loader{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 53px;
        svg{
            color: rgba(${colors.marron_tierra}, 1);
        }
    }
    .container{
        position: relative;
        width: calc(100% - 30px);
        margin-bottom: 15px;
        margin-top: 15px;
        background-color: #FFFFFF;
        padding: 25px 25px;
        border-radius: 12px;
        box-shadow: 4px 0px 23px 0px rgba(0,0,0,0.25);
        -webkit-box-shadow: 4px 0px 23px 0px rgba(0,0,0,0.25);
        -moz-box-shadow: 4px 0px 23px 0px rgba(0,0,0,0.25);
        .bt_close{
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            right: -7px;
            top: -7px;
            width: 36px;
            height: 36px;
            border: 2px solid #FFFFFF;
            border-radius: 18px;
            background-color: rgba(${colors.naranja_pimiento}, 1);
            p{
                display: flex;
                margin: 0;
                padding: 0;
                font-size: 22px;
                color: rgba(${colors.amarillo_banana}, 1);
            }
        }
        .inner{
            display: flex;
            flex-direction: column;
            width: 100%;
            .question{
                font-size: 18px;
                line-height: 24px;
                font-weight: 700;
                text-align: center;
            }
            .answers{
                ul{
                    list-style: none;
                    margin: 20px 0 0 0;
                    padding: 0;
                    li{
                        font-size: 16px;
                        line-height: 22px;
                        font-weight: 600;
                        border: 1px solid #CCCCCC;
                        margin-bottom: 10px;
                        padding: 12px;
                        text-align: center;
                        cursor: pointer;
                        &:hover{
                            background-color: rgba(61,165,224,0.2);
                            border-color: rgba(61,165,224,1);
                            color: rgba(0,55,85,1);
                        }
                        &:last-child{
                            margin-bottom: 0;
                        }
                        &.selected{
                            background-color: rgba(61,165,224,0.2);
                            border-color: rgba(61,165,224,1);
                            color: rgba(0,55,85,1);
                            /*
                            background-color: rgba(231,110,12,1);
                            border-color: rgba(231,110,12,1);//rgba(240,207,80,1);
                            color: #FFFFFF;//rgba(0,55,85,1);
                            */
                        }
                    }
                }
            }
            .actions{
                display: flex;
                justify-content: center;
                width: 100%;
                margin-top: 15px;
                .loader{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;;
                    height: 53px;
                    svg{
                        color: #3DA5E0;
                    }
                }
            }
            .result{
                .box_correct_answer{
                    display: flex;
                    flex-direction: column;
                    margin-bottom: 2vw;
                    color: rgba(${colors.marron_tierra}, 1);
                    border: 1px dashed rgba(${colors.marron_tierra}, 1);
                    background-color: rgba(${colors.blanco_huevo}, 1);
                    padding: 3vw;
                    .box_correct_answer_question{
                        font-weight: 500;
                        font-size: 3.6vw;
                        margin-bottom: 2vw;
                    }
                    .box_correct_answer_description{
                        font-size: 17px;
                        font-weight: 700;
                        color: rgba(${colors.trebol}, 1);
                    }
                    &:last-child{
                        margin-bottom: 0;
                    }
                }
                .result_title{
                    //display: flex;
                    //flex-direction: row;
                    //flex-wrap: wrap;
                    font-size: 5vw;
                    font-weight: 600;
                    margin-bottom: 5vw;
                    padding-bottom: 5vw;
                    border-bottom: 1px solid rgba(${colors.blanco_huevo}, 1);
                    &.win{
                        border-bottom: 0;
                        padding-bottom: 0;
                        margin-bottom: 2vw;
                    }
                    .obtuviste{
                        //display: flex;
                    }
                    .clover{
                        width: 20px;
                        color: rgba(${colors.trebol}, 1);
                        img{
                            width: 100%;
                            float: left;
                        }
                    }
                }
                .correct_answer_title{
                    font-weight: 600;
                    margin-bottom: 2vw;
                }
            }
        }
        /*
        position: relative;
        .inner{
            position: absolute;
        }
        */

        .back_marron_tierra{
            background-color: rgba(${colors.marron_tierra}, 1);
        }
        .back_verde_brocoli{
            background-color: rgba(${colors.verde_brocoli}, 1);
        }
        .back_verde_acelga{
            background-color: rgba(${colors.verde_acelga}, 1);
        }
        .back_azul_agua{
            background-color: rgba(${colors.azul_agua}, 1);
        }
        .back_naranja_pimiento{
            background-color: rgba(${colors.naranja_pimiento}, 1);
        }
        .back_amarillo_banana{
            background-color: rgba(${colors.amarillo_banana}, 1);
        }
        .back_blanco_huevo{
            background-color: rgba(${colors.blanco_huevo}, 1);
        }
        .back_trebol{
            background-color: rgba(${colors.trebol}, 1);
        }

        .text_marron_tierra{
            color: rgba(${colors.marron_tierra}, 1);
        }
        .text_verde_brocoli{
            color: rgba(${colors.verde_brocoli}, 1);
        }
        .text_verde_acelga{
            color: rgba(${colors.verde_acelga}, 1);
        }
        .text_azul_agua{
            color: rgba(${colors.azul_agua}, 1);
        }
        .text_naranja_pimiento{
            color: rgba(${colors.naranja_pimiento}, 1);
        }
        .text_amarillo_banana{
            color: rgba(${colors.amarillo_banana}, 1);
        }
        .text_blanco_huevo{
            color: rgba(${colors.blanco_huevo}, 1);
        }
        .text_trebol{
            color: rgba(${colors.trebol}, 1);
        }

    }

    @media ${breakpoints.xs} {//576px
    }
    @media ${breakpoints.sm} {//768px
        align-items: center;
        .container{
            width: 700px;
            margin-bottom: 0;
            margin-top: 0;
        }
    }
    @media ${breakpoints.md} {//992px
    }
    @media ${breakpoints.lg} {//1200px // Desktop
    }
    @media ${breakpoints.xl} {//1366px
    }
    @media ${breakpoints.xxl} {//1440px
    }
    @media ${breakpoints.xxxl} {//1680px
    }
    @media ${breakpoints.xxxxl} {//1920px
    }

`

export const ButtonStyled = styled.div`
    background-color: #3DA5E0;
    color: #FFFFFF;
    font-weight: 800;
    text-transform: uppercase;
    padding: 13px 25px;
    border-radius: 6px;
    border: 1px solid #3DA5E0;
    cursor: pointer;
    &:hover{
        background-color: #FFFFFF;
        color: #3DA5E0;
        &.disabled{
            cursor: default;
            background-color: #3DA5E0;
            color: #FFFFFF;
        }
    }
    &.disabled{
        opacity: .5;
    }
`


